import React, { FC } from 'react';
import { NotificationModel } from 'api/models';
import NotificationRow from '../NotificationRow/NotificationRow';

interface NotificationGroupProps {
    index: number;
    title: string;
    notifications: NotificationModel[];
    onClose: () => void;
}

const NotificationGroup: FC<NotificationGroupProps> = (props) => {
    const { index, title, notifications, onClose } = props;

    return (
        <div className={index > 0 ? 'pt-4' : 'pt-2'}>
            <div className="px-4 text-grayscale-400 text-xs font-medium">{title}</div>

            <div className="divide-y divide-separator-color-light mt-2">
                {notifications.map((row) => (
                    <NotificationRow key={row._id} notification={row} onClose={onClose} />
                ))}
            </div>
        </div>
    );
};

export default NotificationGroup;
